export default () => ({
  ACCOUNT_STATUS: {
    ACTIVE: 'ACTIVE',
    WAITING_ACTIVATION: 'WAITING_ACTIVATION'
  }
});
